import React from 'react';
import type { IconProps } from '@atlaskit/icon';
import SummaryIcon from '@atlaskit/icon/glyph/activity';
import AppsIcon from '@atlaskit/icon/glyph/addon';
import AttachmentsIcon from '@atlaskit/icon/glyph/attachment';
import BoardIcon from '@atlaskit/icon/glyph/board';
import ListIcon from '@atlaskit/icon/glyph/bullet-list';
import CalendarIcon from '@atlaskit/icon/glyph/calendar';
import ComponentsIcon from '@atlaskit/icon/glyph/component';
import ApprovalsIcon from '@atlaskit/icon/glyph/editor/decision';
import ShortcutsIcon from '@atlaskit/icon/glyph/editor/link';
import FormIcon from '@atlaskit/icon/glyph/editor/media-wrap-left';
import PagesIcon from '@atlaskit/icon/glyph/file';
import ReportsIcon from '@atlaskit/icon/glyph/graph-line';
import IssuesIcon from '@atlaskit/icon/glyph/issues';
import TimelineIcon from '@atlaskit/icon/glyph/roadmap';
import type { JiraNavigationItemTypeKey } from '@atlassian/jira-relay/src/__generated__/ui_navigationKitTabList_TabList.graphql';

type Props = IconProps & {
	typeKey: JiraNavigationItemTypeKey;
};

export const TabIcon = ({ typeKey, ...iconProps }: Props) => {
	switch (typeKey) {
		case 'SUMMARY':
			return <SummaryIcon {...iconProps} />;
		case 'BOARD':
			return <BoardIcon {...iconProps} />;
		case 'LIST':
			return <ListIcon {...iconProps} />;
		case 'CALENDAR':
			return <CalendarIcon {...iconProps} />;
		case 'TIMELINE':
			return <TimelineIcon {...iconProps} />;
		case 'APPROVALS':
			return <ApprovalsIcon {...iconProps} />;
		case 'FORMS':
			return <FormIcon {...iconProps} />;
		case 'PAGES':
			return <PagesIcon {...iconProps} />;
		case 'ATTACHMENTS':
			return <AttachmentsIcon {...iconProps} />;
		case 'ISSUES':
			return <IssuesIcon {...iconProps} />;
		case 'REPORTS':
			return <ReportsIcon {...iconProps} />;
		case 'COMPONENTS':
			return <ComponentsIcon {...iconProps} />;
		case 'APPS':
			return <AppsIcon {...iconProps} />;
		case 'SHORTCUTS':
			return <ShortcutsIcon {...iconProps} />;
		default:
			return null;
	}
};
